import React from 'react';
import './ContactSections.css';
import { useSelector } from 'react-redux';

const ContactSections = () => {

  const contactCopenhagen = useSelector((state) => state.ContactCopenhagen);

  return (
    <div className="contact-sections">
      <div className="contact-section">
        <h3 className="section-title" style={{marginBottom:"30px"}}>{contactCopenhagen?.phoneTitle}</h3>
        <div className="contact-item">
          <h4>{contactCopenhagen?.phoneContactsHeading}</h4>
          <div style={{ marginTop: "5px" }}>
            {contactCopenhagen?.phoneContacts?.map((contact, index) => (
              <p key={index} style={{ color: "#333333" }}>
                {contact.Title}: {contact.Number}
              </p>
            ))}
          </div>
        </div>
        <div className="contact-item">
          <h4>{contactCopenhagen?.accountingCustomsHeading}</h4>
            {contactCopenhagen?.accountingCustomsPhone?.map((contact, index) => (
            <p key={index} style={{ color: "#333333" }}>
              {contact.Title}: {contact.Number}
            </p>
          ))}
        </div>
      </div>

      <div className="contact-section">
        <h3 className="section-title" style={{marginBottom:"30px"}}>{contactCopenhagen?.mailHeading}</h3>
        <div className="contact-item">
          <h4>{contactCopenhagen?.mailingAddressHeading}</h4>
          <p style={{color:"#333333"}}>{contactCopenhagen?.mailingAddress}</p>
        </div>
      </div>

      <div className="contact-section">
        <h3 className="section-title" style={{marginBottom:"30px"}}>{contactCopenhagen?.emailTitle}</h3>
          <div className="contact-item">
            <h4>{contactCopenhagen?.emailHeading}</h4>
            {contactCopenhagen?.customerServiceEmails?.map((email, index) => (
              <p key={index}>
                <a href={`mailto:${email}`} className="email-link">
                  {email}
                </a>
              </p>
            ))}
        </div>
        <div className="contact-item">
          <h4>{contactCopenhagen?.accountingCustomsEmailHeading}</h4>
          {contactCopenhagen?.accountingCustomsEmails?.map((item, index) => (
            <p key={index}>
              <a href={`mailto:${item.email}`} className="email-link">
                {item.email}
              </a>{" "}
              ({item.type})
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactSections;
